var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "csv-record-configuration" },
    [
      _c(
        "a-steps",
        {
          style: _vm.stepStyle,
          attrs: { type: "navigation", size: "small" },
          model: {
            value: _vm.current,
            callback: function ($$v) {
              _vm.current = $$v
            },
            expression: "current",
          },
        },
        [
          _c("a-step", {
            attrs: {
              title: "Upload CSV or Excel file",
              description: "Upload CSV or Excel file",
              status: _vm.current === 0 ? "process" : "wait",
            },
          }),
          _vm._v(" "),
          _c("a-step", {
            attrs: {
              title: "Data Manipulation",
              description: "Map the fields to the columns",
              status: _vm.current === 1 ? "process" : "wait",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.current === 0
        ? _c("div", { staticClass: "fileSelection" }, [
            _c(
              "div",
              { staticClass: "file-box", on: { click: _vm.openSelectFile } },
              [
                _c(
                  "div",
                  {},
                  [
                    _c("a-icon", {
                      staticStyle: { "font-size": "50px", color: "#08c" },
                      attrs: { type: "file-excel" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "file-details" }, [
                  _vm.file
                    ? _c("span", [_vm._v(_vm._s(_vm.file.name))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("wp.selectFile")))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("wp.csvOrExcelFile")))]),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.current === 1
        ? _c("div", { staticClass: "configuration" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("section", { staticClass: "general" }, [
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", [_vm._v(" First Row Contains Header ? ")]),
                      _vm._v(" "),
                      _c("a-switch", {
                        model: {
                          value: _vm.clone.firstRowContainsHeader,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone, "firstRowContainsHeader", $$v)
                          },
                          expression: "clone.firstRowContainsHeader",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.excelMode
                    ? _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("label", [_vm._v(" Seperator Character ")]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              model: {
                                value: _vm.clone.seperator,
                                callback: function ($$v) {
                                  _vm.$set(_vm.clone, "seperator", $$v)
                                },
                                expression: "clone.seperator",
                              },
                            },
                            [
                              _c("a-select-option", { attrs: { value: "," } }, [
                                _vm._v("Comma (,)"),
                              ]),
                              _vm._v(" "),
                              _c("a-select-option", { attrs: { value: ";" } }, [
                                _vm._v("Semicolon (;)"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("a-divider"),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "fields" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._l(_vm.clone.mapping, function (item, index) {
                      return _c(
                        "div",
                        { key: item, staticClass: "field-wrapper" },
                        [
                          _c(
                            "div",
                            { staticClass: "field" },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.clone.mapping[index].field,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.clone.mapping[index],
                                      "field",
                                      $$v
                                    )
                                  },
                                  expression: "clone.mapping[index].field",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("arrow_forward"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field" },
                            [
                              _c("a-select", {
                                attrs: {
                                  value: _vm.clone.mapping[index].dataIndex,
                                  options: _vm.getSelectOptionsForColumns(),
                                },
                                on: {
                                  change: function (value) {
                                    return _vm.changeFieldValue(index, value)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "btnDelete",
                              attrs: { type: "danger", size: "small" },
                              on: {
                                click: function () {
                                  return _vm.clone.mapping.splice(index, 1)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.addField },
                      },
                      [_vm._v("+ " + _vm._s(_vm.$t("calendar.addField")))]
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c(
                "section",
                { staticClass: "result" },
                [
                  _c("label", [_vm._v("Example Result Preview")]),
                  _vm._v(" "),
                  _c("ve-table", {
                    attrs: {
                      columns: _vm.getTableDataSource().columns,
                      "table-data": _vm.getTableDataSource().rows,
                      "row-style-option": _vm.rowStyleOption,
                      "border-x": true,
                      "border-y": true,
                      id: "audit-logs-table",
                      "fixed-header": true,
                    },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "headers" }, [
      _c("label", [_vm._v("AUTOMATION FIELD")]),
      _vm._v(" "),
      _c("label"),
      _vm._v(" "),
      _c("label", [_vm._v("EXCEL/CSV COLUMN")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }